/**
 * withStores
 * HOC for wrapping the provided component with StoreProvider
 */

import React from 'react';
import StoresProvider from './stores-provider';

export default function withStores(WrappedComponent) {
  return function StoresProviderHOC(props) {
    return (
      <StoresProvider {...props}>
        <WrappedComponent {...props} />
      </StoresProvider>
    )
  };
};
